export const GENERATE_FLASHCARDS_SUCCESS="flashcards/GENERATE_FLASHCARDS_SUCCESS";
export const GENERATE_FLASHCARDS_FAILURE="flashcards/GENERATE_FLASHCARDS_FAILURE";


